import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, distinctUntilChanged, map } from 'rxjs';

/**
 * Expose l'état de connectivité réseau du navigateur.
 *
 * S'appuie sur `navigator.onLine` pour l'état initial et sur les évènements
 * `online` / `offline` de la fenêtre pour les changements. Aucune requête
 * réseau n'est émise (pas de ping serveur) : profil A, app-shell uniquement.
 */
@Injectable({ providedIn: 'root' })
export class NetworkStatusService {
  private readonly _online$ = new BehaviorSubject<boolean>(navigator.onLine);

  /** Émet l'état en ligne (true) / hors-ligne (false), sans doublons. */
  readonly online$: Observable<boolean> = this._online$.pipe(
    distinctUntilChanged(),
  );

  /** Émet `true` lorsque l'application est hors-ligne. */
  readonly offline$: Observable<boolean> = this.online$.pipe(map(v => !v));

  constructor() {
    window.addEventListener('online', () => this._online$.next(true));
    window.addEventListener('offline', () => this._online$.next(false));
  }

  get isOnline(): boolean {
    return this._online$.value;
  }
}
